<ng-container *transloco="let t; read: 'installations'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
        </section>
        <section class="oneCol">
          <div class="xs12col">
            <div class="boxContainer">
              <div class="box">
                <h2 class="margin-bottom-medium">{{t('searchTitle')}}</h2>
                <form
                  [formGroup]="filterForm"
                  (ngSubmit)="applyFilter(vm.searchRequest)"
                  class="searchForm">
                  <kendo-formfield>
                    <kendo-label [text]="t('detail.company')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="vm.companies"
                      textField="name"
                      [kendoDropDownFilter]="filterSettings"
                      valueField="id"
                      [defaultItem]="{ id: null, name: t('chooseClient') }"
                      formControlName="companyId"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <div class="searchInputContainer">
                      <span  class="tooltipContainer">
                        <kendo-label [text]="t('keyword')"></kendo-label>
                        <span [attr.tooltip]="t('tooltipSearch')" flow="right" class="tooltipContainer">
                          <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                        </span>
                      </span>
                      <kendo-textbox
                        formControlName="name" class="searchTextField">
                      </kendo-textbox>
                    </div>
                  </kendo-formfield>
                  <div class="buttonContainer margin-bottom-medium">
                    <button
                      [disabled]="filterForm.invalid || !filterForm.dirty"
                      type="submit"
                      kendoButton
                      class="buttonPrimary">
                      {{t('filterSearch')}}
                    </button>
                    <button
                      type="button"
                      [disabled]="!showReset"
                      (click)="resetFilter()"
                      class="buttonSecondary">
                      {{ t('resetFilter') }}
                    </button>
                  </div>
                </form>
                <kendo-grid
                  [data]="vm.installations"
                  [skip]="vm.gridState.skip"
                  [pageSize]="vm.gridState.pageSize"
                  [pageable]="true"
                  [loading]="loading"
                  (pageChange)="pageChangeSub$.next($event)">
                  @if (('Permissions.Installations.Create' | permission)) {
                    <ng-template kendoGridToolbarTemplate>
                      <a kendoGridAddCommand [routerLink]="['new']" class="addIcon">
                        <span class="icon">
                          <img src="../../../assets/icons/add-icon.svg">
                        </span>
                        <span>{{t('add')}}</span>
                      </a>
                    </ng-template>
                  }
                  <kendo-grid-column field="companyName" [title]="t('companyName')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.companyName || '' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="name" [title]="t('name')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.name || '' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="numberOfDevices" [title]="t('numberOfDevices')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.deviceCount}}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-command-column
                    [hidden]="!('Permissions.Installations.Search' | permission)"
                    media="(min-width: 993px)"
                    >
                    <ng-template
                      kendoGridCellTemplate
                      let-isNew="isNew"
                      let-dataItem>
                      <a
                        [routerLink]="[dataItem.id]"
                        [attr.tooltip]="t('open')"
                        flow="up"
                        class="actionIcon">
                        <img src="../../../assets/icons/open-link-icon.svg">
                      </a>
                    </ng-template>
                  </kendo-grid-command-column>
                  <!-- MOBILE GRID -->
                  <kendo-grid-column-group media="(max-width: 992px)">
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('companyName')}}</h4>
                        {{dataItem.companyName || '' }}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('name')}}</h4>
                        {{dataItem.name || '' }}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('numberOfDevices')}}</h4>
                        {{dataItem.deviceCount || '' }}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-command-column
                      [hidden]="!('Permissions.Installations.Search' | permission)">
                      <ng-template
                        kendoGridCellTemplate
                        let-isNew="isNew"
                        let-dataItem>
                        <a
                          [routerLink]="[dataItem.id]"
                          [attr.tooltip]="t('open')"
                          flow="up"
                          class="actionIcon">
                          <img src="../../../assets/icons/open-link-icon.svg">
                        </a>
                      </ng-template>
                    </kendo-grid-command-column>
                  </kendo-grid-column-group>
                  <!-- Paging -->
                  <ng-template
                    let-totalPages="totalPages"
                    let-currentPage="currentPage"
                    kendoPagerTemplate>
                    <div class="flex gridPagination">
                      <div class="flex flexDirRow gridRow">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons
                          [buttonCount]="5"
                        ></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                      <div class="gridRow">
                        <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Small
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Small"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Small }}
                          </button>
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Medium
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Medium"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Medium }}
                          </button>
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Large
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Large"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Large }}
                          </button>
                        </kendo-buttongroup>
                        @if (reloadResults) {
                          <button
                            kendoButton
                            [title]="t('refresh')"
                            class="reloadIcon"
                            (click)="searchRequest$.next(vm.searchRequest)">
                            <img class="actionIcon" src="../assets/icons/reload.svg">
                          </button>
                        }
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoGridNoRecordsTemplate>
                    <div class="text pl">{{t('noResults')}}</div>
                  </ng-template>
                  <ng-template kendoGridLoadingTemplate>
                    <div class="k-loading-color"></div>
                    <div class="loading-container">
                      <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                    </div>
                  </ng-template>
                </kendo-grid>
              </div>
            </div>
          </div>
        </section>
      </div>
    }
  </ng-container>
</ng-container>
